import { render, staticRenderFns } from "./SupportNewDesign.vue?vue&type=template&id=77e246fb&scoped=true"
import script from "./SupportNewDesign.vue?vue&type=script&lang=js"
export * from "./SupportNewDesign.vue?vue&type=script&lang=js"
import style0 from "./SupportNewDesign.vue?vue&type=style&index=0&id=77e246fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e246fb",
  null
  
)

export default component.exports